export default __webpack_public_path__ + "src/assets/icn-faucet.14ec834226cd67ce74b3dee3b7e5b20f.svg";